import React, { useState, useCallback } from 'react';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import ChangePasswordForm from './ChangePasswordForm';

const ChangePasswordPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    async (values: { currentPassword: string; newPassword: string; confirmPassword: string }) => {
      setLoading(true);
      setError('');
      setSuccess('');

      try {
        const response = await fetch(`${BUILD_VARS.QUERY_DOMAIN}/v1.0/profiles/change-password`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify(values),
        });

        const data = await response.json();

        if (response.ok) {
          const successMessage = data.message || 'Password changed successfully.';
          setSuccess(successMessage);
          message.success(successMessage);

          // Redirect to login after successful password change
          setTimeout(() => {
            navigate('/login');
          }, 2000);
        } else {
          const errorMessage = data.message || 'Failed to change password. Please try again.';
          setError(errorMessage);
          message.error(errorMessage);
        }
      } catch (err) {
        const errorMessage = 'Network error. Please check your connection and try again.';
        setError(errorMessage);
        message.error(errorMessage);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return (
    <ChangePasswordForm onSubmit={handleSubmit} loading={loading} error={error} success={success} />
  );
};

export default ChangePasswordPage;
